/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * All fields supporting placeholders in document creation
 */
export enum EnumPlaceholderKinds {
    /**
     * Placeholders for the document representation template of payment terms
     */
    PaymentTermsDocumentRepresentationTemplate = 0,
}
